import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const adminServicesApi = createApi({
  reducerPath: "admin-services",
  tagTypes: ["Services"],
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({

    // ✅ Get all services
    getAllServices: builder.query({
      query: ({ pageno, search, sortOrder, sortBy, all, category, limit }) => {
        let url = `admin/services?pageno=${pageno}`;

        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        if (sortBy) {
          url += `&sortBy=${sortBy}`;
        }
        if (sortOrder) {
          url += `&sortOrder=${sortOrder}`;
        }
        if (all) {
          url += `&all=${all}`;
        }
        if (category) {
          url += `&category=${category}`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }

        return {
          url,
          method: "GET",
        };
      },
      transformResponse: (res) => res,
      providesTags: ["Services"],
    }),

    // ✅ Get single service by ID
    getServiceById: builder.query({
      query: (id) => `admin/service/${id}`,
      transformResponse: (res) => res?.body,
      providesTags: ["Services"],
    }),

    // ✅ Add new service
    addNewService: builder.mutation({
      query: (newService) => ({
        url: `admin/service`,
        method: "POST",
        body: newService,
      }),
      invalidatesTags: ["Services"],
    }),

    // ✅ Update service
    updateService: builder.mutation({
      query: (updatedService) => ({
        url: `admin/service/${updatedService.id}`,
        method: "PUT",
        body: updatedService,
      }),
      invalidatesTags: ["Services"],
    }),

    // ✅ Delete service
    deleteService: builder.mutation({
      query: ({ url }) => ({
        url,
        method: "DELETE",
      }),
      invalidatesTags: ["Services"],
    }),
    updateServiceOrder: builder.mutation({
      query: ({ itemId, newOrder, previousOrder }) => ({
        url: `admin/services/reorder/${itemId}`,
        method: "PUT",
        body: {  newOrder, previousOrder },
      }),
      invalidatesTags: ["Services"],
    }),

  }),
});

export const {
  useGetAllServicesQuery,
  useGetServiceByIdQuery,
  useAddNewServiceMutation,
  useUpdateServiceMutation,
  useDeleteServiceMutation,
  useUpdateServiceOrderMutation,
} = adminServicesApi;
